import { httpClient_ANALYTIC, httpClient_ANALYTIC_FILE } from "./httpClient";
// const END_POINT = "/users";
import store from "../store/store";

const getAnalyticData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_stat`, payload);
};

const getHRActivity = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/hr_activity`, payload);
};

const getHRActivityAlloverview = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/hr_activity_alloverview`, payload);
};

const getCompanyAccess = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_company_access`, payload);
};

const getAnalyticDataAll = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_stat_all_overview`, payload);
};

const getAnalyticDataExcel = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/get_stat_excel`, payload);
};

const getAnalyticDataExcelAll = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/get_stat_excel_all`, payload);
};

const getHRActivityAlloverviewExcel = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/hr_activity_excel_all`, payload);
};

const getAccessHistory = (payload) => {
  const isPage = typeof payload.page !== "undefined";
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(
    `/post/${dataVersion}/get_hr_access${isPage ? `?page=${payload.page}` : ""}`,
    payload
  );
};

const exportAccessHistoryData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/export_hr_access`, payload);
};

const getAccessPages = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_pages`);
};

const getAPICompanyData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/company_data`, payload);
};

const exportCompanyData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/export_company`, payload);
};

const getReportByRegion = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/report_region`, payload);
};

const getLoginTimeReportByRegion = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/report_logintime`, payload);
};

const getLastTwelveMonth = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/last_twelve_month`);
};

const getRegions = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/regions`);
};

const getFirstDateData = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/client_first_date`);
};

const exportOfficeData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/export_region`, payload);
};
const exportLoginTimeDetailsData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/export_login_time_details`, payload);
};

const getMFA = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_mfa`);
};

const getCompanyAndPolicy = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/company`);
};

const getResourceLog = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/resources_log`, payload);
};

const getUserViewed = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/resources_userviewed`, payload);
};

const getAllCompanies = () => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_company_and_account`);
};

const getPolicyUnderCompany = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_policy_under_company`, payload);
};

const getCompaniesByRegion = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_conpanies_by_region`, payload);
};

const getCompanyInfo = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/clients`, payload);
};

const getAllHRunderCompany = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/all_hr_by_company`, payload);
};

const getHRUnderPolicy = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(`/post/${dataVersion}/get_account_under_policy`, payload);
};

const getLastLogin = (payload) => {
  const isPage = typeof payload.page !== "undefined";
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(
    `/post/${dataVersion}/get_last_login${isPage ? `?page=${payload.page}` : ""}`,
    payload
  );
};

const getTotalCompanyByRegion = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC.post(
    `/post/${dataVersion}/total_company${payload.startDate ? `?start_date=${payload.startDate}` : ""
    }${payload.endDate ? `&end_date=${payload.endDate}` : ""}`
  );
};

const exportResourcesLogData = (payload) => {
  const dataVersion = store.state["Layout"].version;
  return httpClient_ANALYTIC_FILE.post(`/post/${dataVersion}/export_resources_log`, payload);
};

export {
  exportAccessHistoryData,
  exportCompanyData,
  exportLoginTimeDetailsData,
  exportOfficeData,
  exportResourcesLogData,
  getAccessHistory,
  getAccessPages,
  getAllCompanies,
  getAllHRunderCompany,
  getAnalyticData,
  getAnalyticDataAll,
  getAnalyticDataExcel,
  getAnalyticDataExcelAll,
  getAPICompanyData,
  getCompaniesByRegion,
  getCompanyAccess,
  getCompanyAndPolicy,
  getCompanyInfo,
  getFirstDateData,
  getHRActivity,
  getHRActivityAlloverview,
  getHRActivityAlloverviewExcel,
  getHRUnderPolicy,
  getLastLogin,
  getLastTwelveMonth,
  getLoginTimeReportByRegion,
  getMFA,
  getPolicyUnderCompany,
  getRegions,
  getReportByRegion,
  getResourceLog,
  getTotalCompanyByRegion,
  getUserViewed
};
